export class AlterarSenhaRequest {
  email: string;
}
